import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getRequest } from "../services/apiMethods";

export default function Home() {
  const Navigate = useNavigate();
  const [highlightedButton, setHighlightedButton] = useState(null);
  const location = useLocation();
  const isUpgradeMode =
    new URLSearchParams(location.search).get("upgrade") === "true";

  const { data: subscriptionsData, isLoading } = useQuery({
    queryKey: ["Subscriptions"],
    queryFn: () => getRequest(`/subscription/list`),
  });

  const handleButtonClick = (id) => {
    setHighlightedButton(id);
    sessionStorage.setItem("subscriptionId", id);
    Navigate(`/register?id=${id}`);
  };

  useEffect(() => {
    let selectedSubscription = sessionStorage.getItem("subscriptionId");
    sessionStorage.setItem("upgrade", isUpgradeMode.toString());
    if (selectedSubscription) {
      setHighlightedButton(selectedSubscription);
    } else {
      setHighlightedButton(null);
    }
  }, []);

  return (
    <>
      <section className="commn-bg-set only-one-respo">
        <div className="card-center-set">
          <div className="commn-card-theme">
            <img
              className="side-logo-set"
              src={require("../Assets/images/logo-main.png")}
            />
            <h2>Our Subscriptions</h2>
            <p>A plan to suit every palette</p>
            <div className="subscriptions-plans">
              {isLoading ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ color: "#e58d2e", minHeight: "200px" }}
                >
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden"></span>
                  </Spinner>
                </div>
              ) : (
                <ul>
                  {Array.isArray(subscriptionsData?.subscriptions) &&
                    subscriptionsData?.subscriptions.length > 0 &&
                    subscriptionsData?.subscriptions.map((ele, index) => {
                      return (
                          <li key={ele?._id}>
                            <div>
                              <h3>{index + 1}</h3>
                              <div className="subscriptions-price">
                                <h4>{ele?.title}</h4>
                                <h5> £{ele?.price} Per month</h5>
                                <p>{ele?.description}</p>
                              </div>
                            </div>
                            <button
                              className={
                                highlightedButton === ele?._id
                                  ? "highlighted"
                                  : ""
                              }
                              onClick={() => {
                                sessionStorage.setItem(
                                  "price_Id",
                                  ele?.price_Id,
                                );
                                sessionStorage.setItem(
                                  "description",
                                  ele?.description,
                                );
                                sessionStorage.setItem("price", ele?.price);
                                sessionStorage.setItem("title", ele?.title);
                                handleButtonClick(ele?._id);
                              }}
                              // onClick={() => {
                              //   sessionStorage.setItem("subscriptionId", ele?._id);
                              //   Navigate(`/register?id=${ele?._id}`)
                              // }}
                            >
                              Join Now
                            </button>
                          </li>
                      );
                    })}
                </ul>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
